module.exports = __webpack_public_path__ + "static/media/sponsor9.a0bc86ea.jpg";